import * as yup from "yup";

export const PolygonSchema = yup.string().required();

export type PolygonSchema = yup.Asserts<typeof PolygonSchema>;
